<template>
    <div class="mx-auto mt-5">
        <div id="header-identificacao" class="row bg-light mb-2">
            <div class="col-sm-12 col-md-12">
                <fieldset class="form-group">
                    <div role="group" class="bv-no-focus-ring">
                        <label for="devedor">Devedor:</label>
                        <input id="devedor" type="text" readonly="readonly" :value="nomeDevedorFormatado()"
                            class="font-weight-bold form-control-plaintext">
                    </div>
                </fieldset>
            </div>
        </div>
        <b-row class="d-flex justify-content-between">
            <!-- Fluxo CES como default conforme solicitado no Mantis https://www.pdsmantis.celepar.pr.gov.br/view.php?id=150259 -->
            <!-- <b-col sm="6" md="4">
                <label style="font-weight: bold;" id="titularReceita">
                    Indique o titular da receita de honorários:
                    <span class="text-danger">*</span>
                    <i class="fas fa-info-circle text-info fa-12x ml-3" variant="info"
                       v-b-modal.modal-info-titular
                       v-b-popover.hover.top="'Clique aqui para saber mais sobre titular da receita de honorários'"></i>
                </label>
            </b-col>
            <b-col sm="6" md="8">
                <b-form-radio-group
                    v-model="requisicao.titularReceita"
                    name="radio-titularReceita"
                    :disabled="configTable.load"
                    @input="consultar();">
                    <b-form-radio value="0">1) FEPGE - Fundo Especial da PGE</b-form-radio>
                    <b-form-radio value="1">2) CES - Caixa Especial de Sucumbência</b-form-radio>
                </b-form-radio-group>
            </b-col> -->
            <b-col>
                <b-button
                        id="btnAnterior"
                        class="mr-2"
                        @click="$emit('prevTab')"
                        variant="secondary"
                        style="height: 40px;" >
                    <i class="fa fa-arrow-left"></i> Anterior
                </b-button>
                <CompBotaoExibirOcultarColuna
                        :fields="fields"
                        :showColunms="showColunms"
                        @toggleColuna="toggleColuna"/>
                <b-button
                        id="btnExibirTodas"
                        class="ml-2"
                        @click="exibirTodas = true"
                        variant="outline-warning"
                        style="height: 40px;"
                        v-if="!exibirTodas">
                    <i class="fa fa-eye"></i> Exibir Todas Requisições
                </b-button>
                <b-button
                        id="btnExibirUltima"
                        class="ml-2"
                        @click="exibirTodas = false"
                        variant="outline-warning"
                        style="height: 40px;"
                        v-if="exibirTodas">
                    <i class="fa fa-eye-slash"></i> Exibir a última Requisição
                </b-button>
            </b-col>
            <b-col style="display: flex; justify-content: center;">
                <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                              :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                              v-if="configTable.perPage != 'Todos'">
                </b-pagination>
            </b-col>
            <b-col class="text-right">
                <b-button class="ml-2 my-2" variant="secondary" @click="limparFiltros"
                          style="margin-right: 10px; height: 40px; padding: 0 0.75rem;">
                    <i class="fas fa-broom"></i> Limpar Filtros
                </b-button>
                <b-form-select v-model="configTable.perPage" :options="[250, 500, 1000, 'Todos']" size="sm"
                               class="col-2" style="height: 40px;"></b-form-select>
                <b-button class="ml-2" id="btnProximaTabela"
                          @click="$emit('nextStep')"
                          :disabled="cdasSelecionadas != null && cdasSelecionadas.length <= 0"
                          variant="primary" style="height: 40px;">
                    Próxima
                    <i class="fa fa-arrow-right"></i>
                </b-button>
            </b-col>
        </b-row>

        <b-table :items="items"
                :fields="fields"
                striped
                small
                responsive="sm"
                :busy="configTable.load"
                show-empty
                hover
                bordered
                class="mb-0"
                head-variant="light">
            <div slot="table-busy" class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Carregando...</strong>
            </div>
            <template slot="empty">
                <p class="my-auto">Nenhuma CDA encontrada.</p>
            </template>
            <template v-slot:head(selecionar)="{ item }">
                <b-form-checkbox v-model="configTable.checkedAll" class="coluna-fixa justify-content-center text-center" @change="toggleAll" />
            </template>
            <template v-slot:cell(selecionar)="{ item }">
                <b-form-checkbox class="coluna-resize mx-auto justify-content-center text-center" style="z-index: 0" :checked="cdasSelecionadas.includes(item)" @change="toggleCheck($event, item)" :disabled="!verificarCdaSelecionavel(item) || verificarCdaJaSelecionada.indexOf(item.codCdaSefa) >= 0" />
            </template>
            <template v-slot:head(1)="{ item }">
                CDA <i class="coluna-fixa filter" :class="!isEmpty(filtros.numeroDivida) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('CDA', 'mascara', '', '##########', $event)"></i>
            </template>
            <template v-slot:cell(1)="{ item }">
                <p class="coluna-resize text-center">
                    <a class="link" @click="abrirModalExtratoCda(item.numeroDivida, item.codOrgaoOrigemDivida)">
                        {{ item.numeroDivida }}
                    </a>
                </p>
            </template>
            <template v-slot:head(2)="{ item }">
                Tipo Crédito <i class="coluna-fixa filter" :class="!isEmpty(filtros.tipoCredito) || filtros.filtrarTipoCredito == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tipo Crédito', 'texto', '', null, $event)"></i>
            </template>
            <template v-slot:cell(2)="{ item }">
                <p class="coluna-resize">
                    {{ item.tipoCredito }}
                </p>
            </template>
            <template v-slot:head(3)="{ item }">
                Situação <i class="coluna-fixa filter" :class="!isEmpty(filtros.situacao) || filtros.filtrarSituacao == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Situação', 'texto', '', null, $event)"></i>
            </template>
            <template v-slot:cell(3)="{ item }">
                <p class="coluna-resize" v-if="item.situacao != null">
                    {{ item.situacao }}
                </p>
                <p class="coluna-resize text-danger" v-if="item.situacao == null">
                    Erro! Repita o processo
                </p>
            </template>
            <template v-slot:head(4)="{ item }">
                Valor Pendente (R$) <i class="coluna-fixa filter" :class="!isEmpty(filtros.valor) || filtros.filtrarValor == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Valor Pendente (R$)', 'numerico', '', null, $event)"></i>
            </template>
            <template v-slot:cell(4)="{ item }">
                <p class="coluna-resize text-right" v-if="item.valor != null">
                    {{ item.valor | currency }}
                </p>
                <p class="coluna-resize text-right text-danger" v-if="item.valor == null">
                    Erro! Repita o processo
                </p>
            </template>
            <template v-slot:head(5)="{ item }">
                REFIS Ativo <i class="filter" :class="!isEmpty(filtros.refisAtivo) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('REFIS Ativo', 'radio', 'N,S', null, $event)"></i>
            </template>
            <template v-slot:cell(5)="{ item }">
                <p class="coluna-resize text-center">
                    {{ item.refisAtivo }}
                </p>
            </template>
            <template v-slot:head(6)="{ item }">
                CNJ <i class="coluna-fixa filter" :class="!isEmpty(filtros.cnj) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('CNJ', 'mascara', '', 'cnj', $event)"></i>
            </template>
            <template v-slot:cell(6)="{ item }">
                <p class="coluna-resize text-center">
                    <a class="link" @click="selecionarTodosCnj(item)">
                        {{ item.cnj }}
                    </a>
                </p>
            </template>
            <template v-slot:head(7)="{ item }">
                Data Ajuizamento <i class="coluna-fixa filter" :class="!isEmpty(filtros.dataAjuizamento) || filtros.filtrarDataAjuizamento == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Ajuizamento', 'data', '', null, $event)"></i>
            </template>
            <template v-slot:cell(7)="{ item }">
                <p class="coluna-resize text-center" :style="item.dataVermelha ? 'color: red' : ''">
                    {{ item.dataAjuizamento }}
                </p>
            </template>
            <template v-slot:head(8)="{ item }">
                {{exibirTodas ? 'Todas as Req. de Hono.' : 'Última Req. de Hono.'}} <i class="coluna-fixa filter" :class="!isEmpty(filtros.numeroRequisicao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Req. de Hono.', 'texto', '', null, $event)"></i>
            </template>
            <template v-slot:cell(8)="{ item }">
                <p class="coluna-resize text-left" v-if="exibirTodas" v-for="requisicao in item.listaHonorariosExecucaoFiscalSefa">
                    <a class="link" @click="abrirModalExtrato(requisicao)" :style="'color: ' + requisicao.cor">
                        {{ requisicao.numeroRequisicao }} {{ requisicao.statusRequisicao }}
                    </a>
                </p>
                <p class="coluna-resize text-left" v-if="!exibirTodas && item.ultimaRequisicao != null">
                    <a class="link" @click="abrirModalExtrato(item.ultimaRequisicao)" :style="'color: ' + item.ultimaRequisicao.cor">
                        {{ item.ultimaRequisicao.numeroRequisicao }} {{ item.ultimaRequisicao.statusRequisicao }}
                    </a>
                </p>
                <p class="coluna-resize text-left" v-if="item.listaHonorariosExecucaoFiscalSefa != null && item.listaHonorariosExecucaoFiscalSefa.length <= 0">
                    Não Emitida
                </p>
            </template>
            <template v-slot:head(9)="{ item }">
                Última TRP emitida <i class="coluna-fixa filter" :class="!isEmpty(filtros.numeroTrp) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Última TRP emitida', 'mascara', '', '##########', $event)"></i>
            </template>
            <template v-slot:cell(9)="{ item }">
                <p class="coluna-resize text-right" v-if="item.trp != null">
                    <a class="link" @click="downloadTrp(item)">
                        {{ item.trpNome }}
                    </a>
                </p>
                <p class="coluna-resize text-left" v-if="item.trp == null">
                    -
                </p>
            </template>
        </b-table>

        <b-row class="d-flex justify-content-between" style="margin-top: 10px;">
            <b-col class="col-md-12">
                <div data-v-48ccbe7e="" class="mb-2" style="margin-right: 30px; float: left;">
                    <div data-v-48ccbe7e="" class="input-group-prepend">
                        <span class="input-group-text">
                            <b>D.A. Ajuizadas:&nbsp; </b>
                            {{configTable.perPage != 'Todos' ? configTable.rows : items.length}}
                        </span>
                    </div>
                </div>
                <div data-v-48ccbe7e="" class="mb-2" style="margin-right: 30px; float: left;">
                    <div data-v-48ccbe7e="" class="input-group-prepend">
                        <span class="input-group-text">
                            <b>D.A. Selecionados:&nbsp;</b>
                            {{cdasSelecionadas != null ? cdasSelecionadas.length : ''}}
                        </span>
                    </div>
                </div>
                <div data-v-48ccbe7e="" class="mb-2" style="float: left;">
                    <div data-v-48ccbe7e="" class="input-group-prepend">
                        <span class="input-group-text">
                            <b>Valor (R$) Seleção:&nbsp;</b>
                            {{ valorSelecionado | currency }}
                        </span>
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-modal
            ref="modal-info-titular"
            id="modal-info-titular"
            size="xl"
            :content-class="'shadow ' + getTheme"
            title="Indique o titular da receita de honorários"
            header-bg-variant="info"
            header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            <p>Com a opção “1) FEPGE - Fundo Especial da PGE” selecionada, será exibida na grid somente as CDAs das execuções fiscais ajuizadas até 17/03/2016 e o sistema, ao final do fluxo, gerará uma Requisição de Honorários devidos ao FEPGE;</p>
                        </li>
                        <li>
                            <p>Com a opção “2) CES - Caixa Especial de Sucumbência” selecionada, será exibida na grid somente as CDAs das execuções fiscais ajuizadas a partir de 18/03/2016 e o sistema, ao final do fluxo, (i) fará o envio de comunicação à CES para a cobrança de honorários devidos à Caixa Especial de Sucumbência quando escolhida a forma de pagamento "Cobrança CES" na tela seguinte ou (ii) emitirá boleto para a conta CES na Requisição gerada quando selecionada a forma de pagamento "Boleto" na tela seguinte.</p>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info')"> Fechar</b-button>
            </template>
        </b-modal>

        <CompLoading ref="loadingTabela"/>

        <ExtratoHonorariosEfSefa
                ref="extratoHonorariosEfSefa"
                :loading="this.$refs.loadingTabela"
                @obterRequisicaoEfSefa="obterRequisicaoEfSefa"
                @closeModal="value => { updated = value; closeModal() }"
                @openFilterModal="openFilter" />
        <ExtratoHonorariosComTransfEfSefa
                ref="extratoHonorariosComTransfEfSefa"
                :loading="this.$refs.loadingTabela"
                @closeModal="value => { updated = value; closeModal() }"
                @openFilterModal="openFilter" />
    </div>
</template>

<script>
    import axios from 'axios'
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompBotaoExibirOcultarColuna from "../../shared/components/CompBotaoExibirOcultarColuna";
    import CompLoading from "../../shared/components/CompLoading";
    import ExtratoHonorariosEfSefa from "../../shared/components/ExtratoHonorariosEfSefa";
    import ExtratoHonorariosComTransfEfSefa from "../../shared/components/ExtratoHonorariosComTransfEfSefa";

    export default {
    props: ['requisicao', 'cdasSelecionadas'],
    components: {ExtratoHonorariosComTransfEfSefa, ExtratoHonorariosEfSefa, CompBotaoExibirOcultarColuna, CompLoading},
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.consultar();
        },
        perPage() {
            this.configTable.currentPage = 1;
            this.consultar();
        },
        'requisicao.titularReceita': function (novoValor, valorAnterior) {
            if (novoValor !== valorAnterior) {
                this.$emit('limpar-cdas-selecionadas'); // cdasSelecionadas é props, portanto o evento está sendo executado
                this.limparValorSelecionado(); // Certifique-se de chamar a função limparValorSelecionado() se necessário
            }
        }
    },
    data() {
        return {
            updated: false,
            urlApi: null,
            token: null,
            exibirTodas: false,
            filtros: {
                numeroDivida: null,
                filtrarTipoCredito: null,
                tipoCredito: null,
                filtrarSituacao: null,
                situacao: null,
                filtrarValor: null,
                valor: null,
                refisAtivo: null,
                cnj: null,
                filtrarDataAjuizamento: null,
                dataAjuizamento: null,
                filtrarNumeroRequisicao: null,
                numeroRequisicao: null,
                numeroTrp: null,
                titularReceita: 0
            },
            filtro: {
                tipo: null,
                campoFiltro: null,
                filtrarEm: null,
                mascara: null,
                campoTexto: null,
                campoMascara: null,
                campoData: null,
                campoRadio: null,
                listaValores: []
            },
            fields: [
                {
                    key: "selecionar",
                }
            ],
            items: [],
            configTable: {
                perPage: 250,
                lastPage: null,
                sortField: 'cda.numerodivida',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false,
            },
            currentScroll: null,
            pesquisaInicial: true,
            valorSelecionado: 0,
            showColunms: []
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage;
        },
        perPage() {
            return this.configTable.perPage;
        },
        getTheme () {
            return this.$store.getters.getTheme
        },
        verificarCdaJaSelecionada() {
            let invalidas = [];
            for(let i = 0; i < this.cdasSelecionadas.length; i++) {
                for(let j = 0; j < this.items.length; j++) {
                    if(this.cdasSelecionadas[i].codCdaSefa != this.items[j].codCdaSefa
                            && this.cdasSelecionadas[i].numeroDivida == this.items[j].numeroDivida) {
                        invalidas.push(this.items[j].codCdaSefa);
                    }
                }
            }
            return invalidas;
        }
    },
    methods: {
        nomeDevedorFormatado() {
            return this.requisicao.devedor.nome +
                (this.requisicao.devedor.documento != null && this.requisicao.devedor.documento.length == 10 ? ' (CNPJ Raiz ' :
                    this.requisicao.devedor.documento != null && this.requisicao.devedor.documento.length <= 14 ? ' (CPF ' : ' (CNPJ ') +
                this.requisicao.devedor.documento + ')';
        },
        async obterColunasUsuario() {
            const funcionalidade = 'honorariosExecucaoFiscalSefaCdaAtiva';

            axios.get(`${this.urlApi}/v1/funcionalidade/configuracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                response.data.forEach((field, i) => {
                    if (field.ativo) {
                        this.showColunms.push(i + 1)
                    }
                    this.fields.push({
                        key: `${i + 1}`,
                        label: `${field.descricao}`,
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            }).catch((error) => {
                this.exibirErro(error)
            })
        },
        verificarCdaSelecionavel(cda) {
	        if (cda.situacao == null || cda.valor == null ) {
		        return false;
	        }
            if (cda.ultimaRequisicao != null &&
                cda.ultimaRequisicao.statusRequisicao != 'rescindido' &&
                cda.ultimaRequisicao.statusRequisicao != 'cancelada' &&
                cda.ultimaRequisicao.statusRequisicao != 'quitada' &&
                cda.ultimaRequisicao.statusRequisicao != 'encaminhada CES') {
                return false;
            }

            if (cda.ultimaRequisicao != null && cda.ultimaRequisicao.statusRequisicao == 'pendente') {
                return false;
            }

            if (cda.cnj===null || cda.cnj==='') {
                return false;
            } 

            return true;
      },
        toggleColuna(i) {
            let ativo;
            if (this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1);
                this.fields[i].thClass = 'd-none';
                this.fields[i].tdClass = 'd-none';
                ativo = false
            } else {
                this.showColunms.push(i);
                this.fields[i].thClass = '';
                this.fields[i].tdClass = '';
                ativo = true
            }

            this.atualizarConfiguracaoColunm(i, ativo)
        },
        toggleAll(checked) {
            if(checked) {
                this.items.forEach(el => {
                    if(!this.cdasSelecionadas.includes(el) && this.verificarCdaSelecionavel(el)) {
                        let possui = false;

                        for(let i = 0; i < this.cdasSelecionadas.length; i++) {
                            for(let j = 0; j < this.items.length; j++) {
                                if(this.cdasSelecionadas[i].codCdaSefa != el.codCdaSefa
                                    && this.cdasSelecionadas[i].numeroDivida == el.numeroDivida) {
                                    possui = true;
                                }
                            }
                        }

                        if(!possui) {
	                        this.valorSelecionado += el.valor;
                            this.cdasSelecionadas.push(el);
                        }
                    }
                })
            } else {
                this.items.forEach(el => {
                    if(this.cdasSelecionadas.includes(el)) {
                        const index = this.cdasSelecionadas.indexOf(el);
                        this.cdasSelecionadas.splice(index, 1);
	                    this.valorSelecionado -= el.valor;
                    }
                })
            }
        },
        selecionarTodosCnj(item) {
            if(this.cdasSelecionadas.includes(item)) {
                this.items.forEach(el => {
                    if(this.cdasSelecionadas.includes(el) && item.cnj == el.cnj) {
                        const index = this.cdasSelecionadas.indexOf(el);
                        this.cdasSelecionadas.splice(index, 1);
	                    this.valorSelecionado -= el.valor;
                    }
                })
            } else {
                this.items.forEach(el => {
                    if(!this.cdasSelecionadas.includes(el) && this.verificarCdaSelecionavel(el) && item.cnj == el.cnj) {
                        let possui = false;

                        for(let i = 0; i < this.cdasSelecionadas.length; i++) {
                            for(let j = 0; j < this.items.length; j++) {
                                if(this.cdasSelecionadas[i].codCdaSefa != el.codCdaSefa
                                    && this.cdasSelecionadas[i].numeroDivida == el.numeroDivida) {
                                    possui = true;
                                }
                            }
                        }

                        if(!possui) {
                            this.cdasSelecionadas.push(el);
	                        this.valorSelecionado += el.valor;
                        }
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                this.cdasSelecionadas.push(item);
				this.valorSelecionado += item.valor;
            } else {
                const index = this.cdasSelecionadas.indexOf(item);
                this.cdasSelecionadas.splice(index, 1);
                this.configTable.checkedAll = false;
	            this.valorSelecionado -= item.valor;
            }

        },
        async atualizarConfiguracaoColunm(i, ativo) {
            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo,
            };
            axios.put(`${this.urlApi}/v1/funcionalidade/configuracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })
        },
        async consultarComScroll() {
            this.currentScroll = document.documentElement.scrollTop;
            if (this.updated) {
                this.consultar();
            }
        },
        async consultar() {
            let perPageStr = `&perPage=${this.configTable.perPage}`;
            if (this.configTable.perPage === 'Todos') {
                perPageStr = '';
                this.configTable.currentPage = 1;
                this.configTable.rows = 0;
            }

            this.filtros.documentoDevedor = this.requisicao.devedor.documento;
            if(this.requisicao.cnj != null && this.requisicao.cnj != "") {
                this.filtros.cnjPrincipal = this.requisicao.cnj;
            }

            this.filtros.titularReceita = this.requisicao.titularReceita;
            this.filtros.documentoDevedor = this.requisicao.devedor.documento;

            this.configTable.load = true;
            axios.post(`${this.urlApi}/v1/honorariosExecucaoFiscalSefa/consultarCda?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.filtros, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.items = response.data.resultado;

                if(this.pesquisaInicial && this.items.length == 1 && this.verificarCdaSelecionavel(this.items[0])) {
                    this.atribuirSelecionadas([this.items[0]]);
                }

                this.pesquisaInicial = false;
                for(var i = 0; i < this.cdasSelecionadas.length; i++) {
                   for (var j = 0; j < this.items.length; j++) {
                       if (this.items[j].codCdaSefa == this.cdasSelecionadas[i].codCdaSefa) {
                           this.cdasSelecionadas[i] = this.items[j];
                       }
                   }
                }

                if (this.configTable.perPage !== 'Todos') {
                    this.configTable.rows = response.data.rows;
                    this.configTable.lastPage = Math.ceil(this.configTable.rows / this.configTable.perPage);
                } else {
                    this.configTable.lastPage = 1;
                }

                if(this.currentScroll != null) {
                    setTimeout(()=>{
                        document.documentElement.scrollTop = this.currentScroll;
                        this.currentScroll = null;
                    }, 100);
                }
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.configTable.load = false;
            })
        },
        atribuirSelecionadas(cdas) {
            this.$emit('selecionarCdas', cdas);
	        cdas.forEach(el => {
		        this.valorSelecionado += el.valor;
	        })
        },
        limparFiltros() {
            this.filtros = {
                numeroDivida: null,
                filtrarTipoCredito: null,
                tipoCredito: null,
                filtrarSituacao: null,
                situacao: null,
                filtrarValor: null,
                valor: null,
                refisAtivo: null,
                cnj: null,
                filtrarDataAjuizamento: null,
                dataAjuizamento: null,
                filtrarNumeroRequisicao: null,
                numeroRequisicao: null,
                numeroTrp: null
            };

            this.consultar();
        },
        openFilter(campo, tipo, values, mascara, event) {
            if(document.getElementById('popup').style.display != 'block'
                || this.filtro.campoFiltro != campo) {
                this.filtro.tipo = tipo;
                this.filtro.campoFiltro = campo;
                this.filtro.mascara = mascara;

                if(this.filtro.campoFiltro == 'CDA') {
                    this.filtro.campoMascara = this.filtros.numeroDivida;
                } else if(this.filtro.campoFiltro == 'Última TRP emitida') {
                    this.filtro.campoMascara = this.filtros.numeroTrp;
                } else if(this.filtro.campoFiltro == 'Req. de Hono.') {
                    this.filtro.filtrarEm = this.filtros.filtrarNumeroRequisicao;
                    this.filtro.campoTexto = this.filtros.numeroRequisicao;
                } else if(this.filtro.campoFiltro == 'Tipo Crédito') {
                    this.filtro.filtrarEm = this.filtros.filtrarTipoCredito;
                    this.filtro.campoTexto = this.filtros.tipoCredito;
                } else if(this.filtro.campoFiltro == 'Situação') {
                    this.filtro.filtrarEm = this.filtros.filtrarSituacao;
                    this.filtro.campoTexto = this.filtros.situacao;
                } else if(this.filtro.campoFiltro == 'CNJ') {
                    this.filtro.campoMascara = this.filtros.cnj;
                } else if(this.filtro.campoFiltro == 'Data Ajuizamento') {
                    this.filtro.filtrarEm = this.filtros.filtrarDataAjuizamento;
                    this.filtro.campoData = this.filtros.dataAjuizamento;
                } else if(this.filtro.campoFiltro == 'Valor Pendente (R$)') {
                    this.filtro.filtrarEm = this.filtros.filtrarValor;
                    this.filtro.campoTexto = this.filtros.valor;
                } else if(this.filtro.campoFiltro == 'REFIS Ativo') {
                    this.filtro.campoRadio = this.filtros.refisAtivo;
                }

                if(this.filtro.tipo == "checkbox") {
                    this.filtro.listaValores = values;
                } else if(values != null && values != "") {
                    this.filtro.listaValores = values.split(',');
                }

                this.$emit('atribuirFiltros', this.filtro);

                this.$emit('openCloseFilterPopup', event);
            } else {
                this.$emit('closeFilterPopup');
            }
        },
        filtrarResultados(limpar) {
            if(limpar) {
                this.filtro.filtrarEm = null;
                this.filtro.campoTexto = null;
                this.filtro.campoData = null;
                this.filtro.campoRadio = null;
                this.filtro.campoCheckbox = null;
                this.filtro.campoMascara = null;
            }

            if(this.filtro.campoCheckbox != null && !Array.isArray(this.filtro.campoCheckbox)) {
                this.filtro.campoCheckbox = [this.filtro.campoCheckbox];
            }

            if(this.filtro.campoFiltro == 'CDA') {
                this.filtros.numeroDivida = this.filtro.campoMascara;
            } else if(this.filtro.campoFiltro == 'Última TRP emitida') {
                this.filtros.numeroTrp = this.filtro.campoMascara;
            } else if(this.filtro.campoFiltro == 'Req. de Hono.') {
                this.filtros.filtrarNumeroRequisicao = this.filtro.filtrarEm;
                this.filtros.numeroRequisicao = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Tipo Crédito') {
                this.filtros.filtrarTipoCredito = this.filtro.filtrarEm;
                this.filtros.tipoCredito = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Situação') {
                this.filtros.filtrarSituacao = this.filtro.filtrarEm;
                this.filtros.situacao = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'CNJ') {
                this.filtros.cnj = this.filtro.campoMascara;
            } else if(this.filtro.campoFiltro == 'Data Ajuizamento') {
                this.filtros.filtrarDataAjuizamento = this.filtro.filtrarEm;
                this.filtros.dataAjuizamento = this.filtro.campoData;
            } else if(this.filtro.campoFiltro == 'Valor Pendente (R$)') {
                this.filtros.filtrarValor = this.filtro.filtrarEm;
                this.filtros.valor = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'REFIS Ativo') {
                this.filtros.refisAtivo = this.filtro.campoRadio;
            }

            this.configTable.currentPage = 1;

            this.consultar();
        },
        ordenarResultados(order) {
            if(this.filtro.campoFiltro == 'CDA') {
                this.configTable.sortField = 'cda.numerodivida';
            } else if(this.filtro.campoFiltro == 'Req. de Hono.') {
                this.configTable.sortField = 'cda.requisicaoEfSefa';
            } else if(this.filtro.campoFiltro == 'Tipo Crédito') {
                this.configTable.sortField = 'cda.tipoCredito';
            } else if(this.filtro.campoFiltro == 'Situação') {
                this.configTable.sortField = 'situacao';
            } else if(this.filtro.campoFiltro == 'CNJ') {
                this.configTable.sortField = 'cda.numerounico';
            } else if(this.filtro.campoFiltro == 'Data Ajuizamento') {
                this.configTable.sortField = 'cda.dataajuizamento';
            } else if(this.filtro.campoFiltro == 'Valor Pendente (R$)') {
                this.configTable.sortField = 'valor';
            } else if(this.filtro.campoFiltro == 'REFIS Ativo') {
                this.configTable.sortField = 'refis';
            } else if(this.filtro.campoFiltro == 'Última TRP emitida') {
                this.configTable.sortField = 'coddossietrp';
            }

            this.configTable.sortOrder = order;

            this.consultar();
        },
        onScroll(e) {
            var thColunas = document.getElementsByClassName("coluna-fixa")[0].parentElement.parentElement;
            var commandLine = document.getElementById("btnAnterior").parentElement.parentElement;

            commandLine.style.position = 'sticky';
            commandLine.style.top = '60px';
            commandLine.style.zIndex = 2;
            commandLine.classList.add("background-scroller");

            thColunas.style.position = 'sticky';
            thColunas.style.top = (59 + commandLine.offsetHeight) + 'px';
            thColunas.style.zIndex = 1;
        },
        closeModal() {
            this.consultarComScroll();
            this.updated = false;
        },
        abrirModalExtrato(item) {
            if(item.tabela == 4) {
                this.$refs['extratoHonorariosEfSefa'].abrirExtrato({
                    id: item.codRequisicao,
                    tabelaOrigem: 4,
                    numeroRequisicao: item.numeroRequisicao
                });
            } else if(item.tabela == 5) {
                this.$refs['extratoHonorariosComTransfEfSefa'].abrirExtrato({
                    id: item.codRequisicao,
                    tabelaOrigem: 5,
                    numeroRequisicao: item.numeroRequisicao
                });
            }
        },
        obterRequisicaoEfSefa(id, avancarDois) {
            this.$emit('obterRequisicaoEfSefa', id, avancarDois);
        },
        abrirModalExtratoCda(numeroCda, codOrgaoOrigemDivida) {
            this.$emit('abrirExtratoCda', numeroCda, codOrgaoOrigemDivida);
        },
        async downloadTrp(item) {
            this.$refs.loadingTabela.showLoading();
            if (!item.trpGuiasAntigo) {
                axios.get(`${this.urlApi}/v1/cancelarTrp/downloadAnexo/${item.trp}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    },
                    responseType: 'arraybuffer'
                })
                    .then(response => {
                        if(!response.data || !response.data.byteLength){
                            this.exibirMensagem('Arquivo não encontrado para download.');
                            return;
                        }

                        let blob = new Blob([response.data], { type: 'application/pdf' });
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'trp_' + item.trpNome.split(' ')[1].replace('/', '_') + '.pdf';
                        link.click();
                    }).finally(() => {
                    this.$refs.loadingTabela.hideLoading();
                })
            } else {
                axios.get(`${this.urlApi}/v1/trp/downloadTrpGuias/${item.trp}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    },
                    responseType: 'arraybuffer'
                })
                    .then(response => {
                        if(!response.data || !response.data.byteLength){
                            this.exibirMensagem('Arquivo não encontrado para download.');
                            return;
                        }

                        let blob = new Blob([response.data], { type: 'application/pdf' });
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'trp_' + item.trpNome.split(' ')[1].replace('/', '_') + '.pdf';
                        link.click();
                    }).finally(() => {
                    this.$refs.loadingTabela.hideLoading();
                })
            }
        },
	    limparValorSelecionado() {
		    this.valorSelecionado = 0;
	    },
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;
        
        // Fluxo CES como default conforme solicitado no Mantis https://www.pdsmantis.celepar.pr.gov.br/view.php?id=150259
        this.requisicao.titularReceita = 1;

        this.obterColunasUsuario();

        window.addEventListener("scroll", this.onScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.onScroll)
    },

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
